import { localTranslations } from "@/locales/globus";

const translate = window.useGlobusLocal("globus");

const getLang = () => {
  const lang = (localStorage.getItem("globusLanguage") || "ru").toLowerCase();
  const shortLang = lang.slice(0, 2);

  return localTranslations[shortLang] ? shortLang : "ru";
};

export const t = (key) => {
  const value = typeof translate === "function" ? translate(key) : key;
  if (value && value !== key) return value;

  return localTranslations[getLang()]?.[key] || localTranslations.ru[key] || key;
};
